<!-- @format -->

<div class="list-container">
  <dl
    [class.fill-by-column]="fillByColumn === true"
    [class.fill-by-row]="fillByColumn === false"
    [class.one-column]="columnCount === 1"
    role="list">
    <div *ngFor="let template of childTemplates" class="tiny-static-form-group" role="listitem">
      <ng-container [ngTemplateOutlet]="template"></ng-container>
    </div>
  </dl>
</div>
